/** Home page talks, newest first, in the same rows as the awards. */
import React from 'react';

import { useSiteMetadata } from '../../../utils/hooks';
import { DatedList } from './Awards';

/** Render every talk listed in the site config. */
const Talks = () => {
  const { talks } = useSiteMetadata();
  if (!talks || talks.length === 0) return null;
  return <DatedList heading="Talks" items={talks} />;
};

export default Talks;
